import React, { useContext, useEffect } from "react";
import useTitle from "../../../hooks/useTitle";
import { ThemeContext } from "../../../context/ThemeContext";
import atm_pressure from "./asset/atm_pressure.png";
import wind_icon from "./asset/wind.png";
import solar_voltage from "./asset/solar_voltage.png";
import battery_voltage from "./asset/battery_voltage.png";
import battery_charging_current from "./asset/battery_charging_current.png";
import batter_charging from "./asset/battery_charging.png";
import wind_direction from "./asset/wind_direction.png";

//graph icons
import co2 from "./asset/graphAssets/co2.png";
import rainfall from "./asset/graphAssets/rainfall.png";
import co from "./asset/graphAssets/co.png";
import ch4 from "./asset/graphAssets/ch4.png";
import pm2_5 from "./asset/graphAssets/pm2_5.png";
import pm_10 from "./asset/graphAssets/pm_10.png";
import temp from "./asset/graphAssets/temp.png";
import humidity from "./asset/graphAssets/humidity.png";

//soil icons
import ph from "./asset/soilAssets/ph.png";
import moisture from "./asset/soilAssets/moisture.png";
import conductivity from "./asset/soilAssets/conductivity.png";
import nitrogen from "./asset/soilAssets/nitrogen.png";
import phosphorus from "./asset/soilAssets/phosphorus.png";
import potassium from "./asset/soilAssets/potassium.png";
import water_level from "./asset/soilAssets/water_level.png";
import solar_radiation from "./asset/solar_radiation.png";

import "./styles/brriStyle.css";
import BrriValueCard from "./BrriValueCard";
import BrriGraphCard from "./BrriGraphCard";
import BrriLineChart from "./BrriLineChart";
import BrriGauge from "./BrriGauge";
import Temp from "./Temp";
import { useGetBrriDashboardDataQuery } from "../../../features/brri/dashboardApi";
import { useLazyGetBrriDashboardDataQuery } from "../../../features/brri/dashboardApi";

import { useGetWeatherDashboardDataQuery } from "../../../features/bau/dashboardApi";
import { useLazyGetWeatherDashboardDataQuery } from "../../../features/bau/dashboardApi";

import mqtt from "mqtt/dist/mqtt";
import timeAgo from "../../../helper/timeAgo";
import BrriSoilCard from "./BrriSoilCard";

import { generatePath, useNavigate } from "react-router-dom";

import { TbListDetails } from "react-icons/tb";

//card icons
import { FiWind } from "react-icons/fi";
import { GiCompass } from "react-icons/gi";
import { ImPower } from "react-icons/im";
import { MdBatteryChargingFull } from "react-icons/md";

//graph icons
import { CiTempHigh } from "react-icons/ci";
import { WiHumidity } from "react-icons/wi";
import { FaCloudRain } from "react-icons/fa";
import { BsSunsetFill } from "react-icons/bs";
import { WiCloudyWindy } from "react-icons/wi";

function WeatherDashboard() {
  useTitle("BAU Dashboard");
  const theme = useContext(ThemeContext);
  const navigate = useNavigate();

  let { data, isLoading } = useGetWeatherDashboardDataQuery();
  const [getWeatherDashboardData, results] =
    useLazyGetWeatherDashboardDataQuery();

  let options = {
    clientId: Math.random(),
    username: "shahed",
    password: "Aqualink_321",
    // clean: true,
    reconnectPeriod: 1000,
    port: 8082,
  };

  let client = mqtt.connect("mqtts://mqtt.aqualinkbd.com", options);
  useEffect(() => {
    client.subscribe("/weather/data");

    // Update the document title using the browser API
    client.on("message", (topic, message) => {
      console.log(topic, message.toString());
      getWeatherDashboardData();
    });
    return () => {
      client.end(); // Clean up to prevent resource leaks
    };
  }, [client]);

  // const icons = {
  //   SOLARVOLTAGE: solar_voltage,
  //   BATTERYVOLTAGE: battery_voltage,
  //   BATTERYCHARGINGCURRENT: battery_charging_current,
  //   DEVICECURRENT: batter_charging,
  //   ATMOSPHERICPRESSURE: atm_pressure,
  //   WINDSPEED: wind_icon,
  //   WINDDIRECTION: wind_direction,
  //   LOADCURRENT: battery_charging_current,
  //   "PM2.5": pm2_5,
  // };
  const icons = {
    SOLARVOLTAGE: solar_voltage,
    BATTERYVOLTAGE: (
      <MdBatteryChargingFull
        color={theme === "dark" ? "white" : "black"}
        size={30}
      />
    ),
    BATTERYCHARGINGCURRENT: battery_charging_current,
    DEVICECURRENT: batter_charging,
    ATMOSPHERICPRESSURE: atm_pressure,
    WINDSPEED: (
      <FiWind color={theme === "dark" ? "white" : "black"} size={30} />
    ),
    WINDDIRECTION: (
      <GiCompass color={theme === "dark" ? "white" : "black"} size={30} />
    ),
    LOADCURRENT: (
      <ImPower color={theme === "dark" ? "white" : "black"} size={27} />
    ),
    "PM2.5": pm2_5,
  };
  const graphIcons = {
    TEMPERATURE: (
      <CiTempHigh color={theme === "dark" ? "white" : "black"} size={80} />
    ),
    HUMIDITY: (
      <WiHumidity color={theme === "dark" ? "white" : "black"} size={85} />
    ),
    RAINFALL: (
      <FaCloudRain color={theme === "dark" ? "white" : "black"} size={75} />
    ),
    CO2: co2,
    CO: co,
    CH4: ch4,
    PM10: pm_10,
    ATMPRESSURE: (
      <WiCloudyWindy color={theme === "dark" ? "white" : "black"} size={80} />
    ),
    WINDSPEED: atm_pressure,
    SOLARRADIATION: (
      <BsSunsetFill color={theme === "dark" ? "white" : "black"} size={80} />
    ),
    "PM2.5": pm2_5,
  };
  const soilIcons = {
    PH: ph,
    MOISTURE: moisture,
    SOILTEMP: temp,
    CONDUCTIVITY: conductivity,
    NITROGEN: nitrogen,
    PHOSPHORUS: phosphorus,
    POTASSIUM: potassium,
    WATERLEVEL: water_level,
  };
  let latestTimeStamp;
  let brriCardData = [];
  let gaugeData = [];
  let soil_device_1_data = [];
  let soil_device_2_data = [];
  let soil_device_3_data = [];
  let soil_device_4_data = [];
  let soil_device_5_data = [];
  let soil_device_6_data = [];

  let time_ago = "";
  if (!isLoading) {
    if (results.data) {
      // console.log("results");
      // console.log(results.data);
      data = results?.data;
    }
    // console.log(data);
    brriCardData = data?.data;
    // console.log(brriCardData);
    gaugeData = data?.gauge_data;
    soil_device_1_data = data?.soil_device_1;
    soil_device_2_data = data?.soil_device_2;
    soil_device_3_data = data?.soil_device_3;
    soil_device_4_data = data?.soil_device_4;
    soil_device_5_data = data?.soil_device_5;
    soil_device_6_data = data?.soil_device_6;
    brriCardData = brriCardData?.map((item) => {
      const iconName = item.sensor_name.split(" ").join("");

      return {
        ...item,
        iconName: iconName,
      };
    });
    gaugeData = gaugeData?.map((item) => {
      const iconName = item.sensor_name.split(" ").join("");

      return {
        ...item,
        iconName: iconName,
      };
    });
    soil_device_1_data = soil_device_1_data?.map((item) => {
      const iconName = item.sensor_name.split(" ").join("");

      return {
        ...item,
        iconName: iconName,
      };
    });
    soil_device_2_data = soil_device_2_data?.map((item) => {
      const iconName = item.sensor_name.split(" ").join("");

      return {
        ...item,
        iconName: iconName,
      };
    });
    soil_device_3_data = soil_device_3_data?.map((item) => {
      const iconName = item.sensor_name.split(" ").join("");

      return {
        ...item,
        iconName: iconName,
      };
    });
    soil_device_4_data = soil_device_4_data?.map((item) => {
      const iconName = item.sensor_name.split(" ").join("");

      return {
        ...item,
        iconName: iconName,
      };
    });
    soil_device_5_data = soil_device_5_data?.map((item) => {
      const iconName = item.sensor_name.split(" ").join("");

      return {
        ...item,
        iconName: iconName,
      };
    });
    // latestTimeStamp = new Date(brriCardData[0]?.updated_at);
    // console.log(latestTimeStamp);

    // latestTimeStamp = date?.toLocaleString();
    const date = new Date(brriCardData[0]?.updated_at);

    const formatDate = (date) => {
      const options = {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true, // Ensures am/pm format
      };
      return new Intl.DateTimeFormat("en-GB", options).format(date);
    };

    latestTimeStamp = formatDate(date);

    // if (latestTimeStamp) {
    //   time_ago = timeAgo(latestTimeStamp);
    // }
  }

  const soilClickHandler = (slave_id) => {
    const path = generatePath("/soilDetails/:slaveId", { slaveId: slave_id });
    navigate(path);
  };

  return (
    <div>
      <div className={`container-fluid ${theme}`}>
        <div className="card theme-background">
          <div
            className="brri-timestamp theme-text"
            style={{ textAlign: "center", padding: "10px", fontSize: "18px" }}
          >
            {/* Last Updated : {time_ago} (BAU) */}
            Last Updated : {latestTimeStamp}
          </div>
        </div>

        <div className="row ">
          {brriCardData?.map((cardInfo) => {
            return (
              <div className="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <BrriValueCard
                  icon={icons[cardInfo?.iconName]}
                  value={cardInfo?.value}
                  unit={cardInfo?.unit}
                  title={cardInfo?.sensor_name}
                  sensorId={cardInfo?.sensor_id}
                />
              </div>
            );
          })}
        </div>

        <div className="row">
          {/* <div className="col-md-4">
            <div className="card theme-background brri-graph-container">
              <div className="row">
                <div className="col-md-3 brri-graph-container">
                  <div className="brri-graph-title theme-text">Temperature</div>
                  <div className="brri-graph-icon">
                    <Temp value={25} />
                  </div>
                </div>
                <div className="col-md-9">
                  <BrriLineChart />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card theme-background brri-graph-container">
              <div className="row">
                <div className="col-md-3 brri-graph-container">
                  <div className="brri-graph-title theme-text">Humidity</div>
                  <div className="brri-graph-icon">
                    <BrriGauge value={80} unit={"%"} />
                  </div>
                  <div className="brri-graph-value theme-text">80 %</div>
                </div>
                <div className="col-md-9">
                  <BrriLineChart />
                </div>
              </div>
            </div>
          </div> */}
          {gaugeData?.map((gaugeItem) => {
            const chartData = {
              label: gaugeItem?.chart_Label,
              value: gaugeItem?.chart_value,
            };
            return (
              <div className="col-md-12 col-xl-4 col-lg-6 col-sm-6">
                <BrriGraphCard
                  value={gaugeItem?.value}
                  title={gaugeItem?.sensor_name}
                  unit={gaugeItem?.unit}
                  icon={graphIcons[gaugeItem?.iconName]}
                  chartData={chartData}
                  sensorId={gaugeItem?.sensor_id}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default WeatherDashboard;
